import _ from 'lodash';

function getCompsForType(types, scopedRMI, type, onlyNestedScope) {
    return _.transform(types.getPotentialViewerTypes(type), (result, value) => {
        const compIds = scopedRMI.getCompIdsFromType(value, onlyNestedScope) || [];
        const ghostIds = scopedRMI.getGhostCompIdsFromType ?
          scopedRMI.getGhostCompIdsFromType(value, onlyNestedScope) || [] :
          [];
        _.concat(compIds, ghostIds).forEach((compId) => {
            if (getSdkPublicName(types, scopedRMI, compId) === type) {
                result.push({
                    id: compId,
                    type: value
                });
            }
        });
    }, []);
}

function getCompIdsForRole(scopedRMI, role, onlyNestedScope) {
    const compIds = scopedRMI.getCompIdsFromRole(role, onlyNestedScope);
    const ghostIds = scopedRMI.getGhostCompIdsFromRole ? scopedRMI.getGhostCompIdsFromRole(role, onlyNestedScope) : [];
    return _.concat(compIds, ghostIds);
}

function getSdkConstructorName(types, RMI, compId) {
    const compType = RMI.getType(compId);
    const compData = RMI.getData(compId);
    if (!compType) {
        return null;
    }
    /**
     * Temporary fix for proGallery wixCodeSDK so they can rollout their Iframe/Native Mode to some users.
     * Once they will finish rollout we can remove this code together with this code:
     * https://github.com/wix-private/santa-core/blob/2c230728281e247c7df79d89ba446d37ef4ced27/santa-platform-utils/src/typeUtils/typeData.js#L77
     * This will enable proGallery to expose wixCode API via the controller and not ProGallery.es6
     */
    if (compType === 'wysiwyg.viewer.components.tpapps.TPAWidgetNative' &&
        _.get(compData, 'widgetId') === '142bb34d-3439-576a-7118-683e690a1e0d') {
        return 'Native';
    }
    return types.getSdkConstructorName(compType, compData);
}

function getSdkPublicName(types, RMI, compId) {
    const compType = RMI.getType(compId);
    const compData = RMI.getData(compId);
    if (!compType) {
        return null;
    }
    return types.getSdkConstructorName(compType, compData);
}

export default {
    getCompsForType,
    getCompIdsForRole,
    getSdkConstructorName,
    getSdkPublicName
};
